var map = {
	"./account.svg": "mBRL",
	"./appreciate.svg": "YjFd",
	"./loading.svg": "Pn4N",
	"./lotter_title.svg": "v2lbT",
	"./question.svg": "Yn10",
	"./right.svg": "Jlp2",
	"./wrong.svg": "ZGrs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fEWm";


//////////////////
// WEBPACK FOOTER
// ./src/components/game/common-component/svg-icon/svg-doc nonrecursive \.svg$
// module id = fEWm
// module chunks = 216